import { GetterTree, Getter } from 'vuex'
import { IRootState } from '~/store'
import { WarrantyState } from '~/store/warranty/state'

type WarrantyGetter = Getter<WarrantyState, IRootState>

export const products: WarrantyGetter = ({ products }) => products

export default { products } as GetterTree<WarrantyState, IRootState>
